<template lang="pug">
  li.item-container.establishment-tile(:style="`grid-template-columns: ${selectable ? '4em' : '0'} 180px 1fr 1fr 1fr ${actions.length ? '10em' : '0'};`")
    .attribute.select-establishment
      label.checkbox-wrapper(v-if="selectable")
        input(type="checkbox" @change="select" :checked="selected")
        .checkbox-indicator
    .attribute.thumbnail
      img(:src="`data:image/png;base64, ${establishment.group_info.thumbnail || fallbackThumbnail}`")
    .attribute-container.establishment-info
      .attribute.justify-left.name {{ establishment._name }}
      .attribute-container.address
        .attribute.justify-left
          .city {{ address.city }},
          .zip  {{ address.zip }}
        .attribute.justify-left
          .detail {{ address.value }}
    .attribute.sheet-count(v-if="establishment.sheets")
      a(@click="goToEstablishment") {{ establishment.sheets.length }} fiches liées à cet établissement
    .attribute.account-name(v-if="establishment.group_info") {{ establishment.group_info.name }}
    .attribute-container.actions
      .attribute.action(v-for="action in actions" :key="action.event")
        button(@click="triggerAction(action)") {{ action.label }}
</template>

<script>
export default {
	props: {		
    establishment: {
      type: Object,
			required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
	},
  name: 'EstablishmentTile',
  data() {
    return {
      fallbackThumbnail: '/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAsNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ3/wQARCAB4ALQDABEAAREAAhEA/8QAUwABAAMBAAMAAAAAAAAAAAAAAAMEBQECBgcQAQACAQIBBgoIBwEAAAAAAAABAgMREgQhMTJCUmETIjRBUWJygqHwFBUjcYGRkqIzQ1NzssHC8f/aAAwDAAABAAIAAD8A+uOOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKmTi8OOdus3v2aRu5fR6ARfSsvPHCZtPn1QdrxuPXbkrfDb16zoC9ExMRMTExPNMaTGnpiQdAAAAAAAAAAAAAAAAABm5b34jJPD4Z20r/GyR8a1n4etbXqxYFvFgx4Y0pWO+3Wn59EeKCcHhelL1nfWtq+t88gMWmeMGW/gd9+GiY3eeK8vSp+PR7YNysxaItE6xMaxIOgAAAAAAAAAAAAAAAg4jJ4LDkv54rO32p5K/GQQYK+A4bfprbZOW3fO3dHL93ICh9YZuxj/AHAqR4XLk313Ta1t26NYiLa66zbmrEd/RrALuXPfPHg4vWMdY+2yxExSfjrt15Kx0stgXeFrivw81rTSlptW27ltbSelbvmOXTq9UHOCmYrkw25Zw3msezMzp8Yn8wXwAAAAAAAAAAAAAAAUeP8AJ7e1XX7t3/gJsnk9/wCzb8tgPWq1te0VrGsz86/dEctpnog1LWtxExw3DeLhrEb7+aYj0+rr717Ao5rRFpxUn7OlpiNOvaI0te0+eddYr1a16INjgPJ/fuDmDyvivc/MGgAAAAAAAAAAAAAAACLNj8LivTtVkFXh7xl4e2O07bUrbFfXniNJrFuXu/dEgzaY5vM4ME6x/Nzac8a9H2O7pXt0gXbcHk02Y8sUx9mN2tvWvyxumfR0a18WoIfq6/8AVr+kF/HWOFwTutrt3WmdNNder/qoI+CrbZfLbpZr7/d18X57OgL4AAAAAAAAAAAAAAAAMvi+GvO7Lh11tGmWkdeO6PPPajrf5BJwuXh4pGOk7L9at9ItNvx5Lf8APZBoAhyZsWKNb3rHdz2/SCjpk4y0Tas04as6xWelk757u/o16vjA1IjSNI5o00jzcnNAAAAAAAAAAAAAAAAAAAIMnD4cvTpHtR0gVvoGLt5o7t4JcfB4Mc67N0+m87gWwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAf/2Q==',
    }
  },
  methods: {
    select(e) {
      this.$emit('select', {
        selected: e.target.checked,
        establishmentId: this.establishment.id,
      });
    },
    goToEstablishment() {
      this.$emit('goToEstablishment', { establishmentId: this.establishment.id });
    },
    triggerAction(action) {
      this.$emit('action', {
        event: action.event,
        establishmentId: this.establishment.id,
      });
    },
  },
  computed: {
    address() {
      const parent = this.establishment.group_info || this.establishment.location;
      return parent.address;
    }
  },
};
</script>

<style lang="scss">
  .establishment-tile {
    color: #1A1A1A;
    font-size: 20px;
    .address {
      color: #BCBCBC;
      font-size: 18px;
      .detail {
        font-size: 16px;
        font-style: italic;
      }
    }
    .sheet-count a {
      cursor: pointer;
      text-decoration: underline;
    }
  }
</style>